import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { updateDeliveryPersonnel } from "../../api/Api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70vw",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: "none",
};

const UpdateDeliveryPersonModal = ({
  open,
  handleClose,
  userData,
  handleUpdateUser,
}) => {
  const [updatedData, setUpdatedData] = useState({
    name: "",
    area: "",
    phone_number: "",
    email: "",
    vehicle_number: "",
    availability_status: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userData) { 
      setUpdatedData({
        name: userData.name || "",
        area: userData.area || "",
        phone_number: userData.phone_number || "",
        email: userData.email || "",
        vehicle_number: userData.vehicle_number || "",
        availability_status: userData.availability_status || "",
      });
    }
  }, [userData]);

  const handleChange = (e) => {
    setUpdatedData({
      ...updatedData,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading
    try {
      if (JSON.stringify(updatedData) !== JSON.stringify(userData)) {
        await updateDeliveryPersonnel(updatedData);
        handleUpdateUser(updatedData);
      }
    } catch (error) {
      console.error("Error updating delivery personnel:", error);
    } finally {
      setLoading(false); // Stop loading
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
      }}
    >
      <Box sx={style} component="form" onSubmit={handleUpdate}>
        <Box
          sx={{
            backgroundColor: "#2196F3",
            padding: "20px",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography id="update-item-modal-title" variant="h6" component="h2">
            Update Delivery Person
          </Typography>
          <Button
            onClick={handleClose}
            style={{ color: "#fff", fontSize: "1.2rem" }}
          >
            ✖
          </Button>
        </Box>

        <Box sx={{ padding: "20px" }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={updatedData.name}
                variant="outlined"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={updatedData.email}
                variant="outlined"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Contact No"
                name="phone_number"
                value={updatedData.phone_number}
                variant="outlined"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Delivery Area"
                name="area"
                value={updatedData.area}
                onChange={handleChange}
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Vehicle Number"
                name="vehicle_number"
                value={updatedData.vehicle_number}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined" required>
                <InputLabel>Availability Status</InputLabel>
                <Select
                  label="Availability Status"
                  name="availability_status"
                  value={updatedData.availability_status}
                  onChange={handleChange}
                >
                  <MenuItem value="Available">Available</MenuItem>
                  <MenuItem value="Unavailable">Unavailable</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box textAlign="right" mt={4}>
            <Button
              type="submit"
              variant="contained"
              sx={{
                width: "180px",
                height: "50px",
                backgroundColor: loading ? "#BDBDBD" : "#FF893A",
                textTransform: "capitalize",
              }}
              disabled={loading} // Disable button during loading
            >
              {loading ? "Updating..." : "Update Data"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default UpdateDeliveryPersonModal;
